import { TechFetchSearch } from 'wisestep-api';

import BasicSearchForm from '../../types/IBasicSearchForm';

import { States } from './defaultAdvanceFilterValues';

export default function (values: BasicSearchForm & TechFetchSearch) {
  const query: TechFetchSearch = {
    allAny: 'Any',
    ...values,
    resumesPostedWithinDays: values.lastActive,
    workAuthorization: values.workAuthorizations?.toString(),
    domainExposure: values.domainExposures?.toString(),
    degree: values.degrees?.toString(),
    usExperience: values.usExperiences?.toString(),
    experience: values.experiences?.toString(),
    preferredEmployment: values.preferredEmploymentTypes?.toString(),
    stateCodes: values.location?.map((data) => States[data]).toString(),
    keywords: values.query,
    pageNumber: values.page,
    resultsPerPage: values.pageSize,
    sortBy: values.sort,
  };
  return query;
}
